export default __webpack_public_path__ + "static/media/Two.ad3f2280.svg";